module.exports = __webpack_public_path__ + "static/media/photoshop.816abc0f.svg";